// Spacing and shape configuration for MUI theme

export const breakpoints = {
  values: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  },
}

export const spacing = factor => `${0.25 * factor}rem` // Base unit: 4px

export const shape = {
  borderRadius: 8,
}

export const shadows = [
  'none',
  '0 1px 2px 0 rgba(0, 0, 0, 0.05)', // --shadow-sm
  '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // --shadow-md
  '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)', // --shadow-lg
  '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)', // --shadow-xl
  '0 25px 30px -7px rgba(0, 0, 0, 0.15), 0 15px 15px -7px rgba(0, 0, 0, 0.08)',
  '0 30px 35px -9px rgba(0, 0, 0, 0.2), 0 20px 20px -9px rgba(0, 0, 0, 0.12)',
  '0 35px 40px -11px rgba(0, 0, 0, 0.25), 0 25px 25px -11px rgba(0, 0, 0, 0.16)',
  '0 40px 45px -13px rgba(0, 0, 0, 0.3), 0 30px 30px -13px rgba(0, 0, 0, 0.2)',
  '0 45px 50px -15px rgba(0, 0, 0, 0.35), 0 35px 35px -15px rgba(0, 0, 0, 0.24)',
  // ... up to 24 shadows as required by MUI
  ...Array(14).fill(
    '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  ),
]

export const zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500,
}

export const transitions = {
  duration: {
    shortest: 150,
    shorter: 200,
    short: 250,
    standard: 300,
    complex: 375,
    enteringScreen: 225,
    leavingScreen: 195,
  },
  easing: {
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
  },
}
